<template>
  <div>
    <modal
      v-if="
        statusCodesToEnableDwV.includes(caseDetails.statusCode) &&
        disputeStatusToEnableDwV.includes(caseDetails.disputeStage)
      "
      size="medium"
      primary-button-label="Save"
      tertiary-button-label="Cancel"
      :delete-button-label="showDelete ? 'Delete' : ''"
      :close-on-click-outside="false"
      active
      class="voice-modal"
      @onClose="onClose()"
      @onConfirm="onSubmitClick()"
      @onDelete="onDelete()">
      <div slot="header">Update voice (DwV)</div>
      <div slot="content">
        <dispute-with-voice-form
          ref="disputeWithVoiceForm"
          v-bind="$props"
          @onSubmit="onSubmit" />
      </div>
    </modal>
    <modal
      v-else
      size="small"
      close-on-click-outside
      active
      class="alert"
      @onClose="onClose()">
      <div slot="header">Alert</div>
      <div slot="content">
        <div class="alert">
          <icon size="24" name="exclamation-circle" />
          <div class="alert__content">
            <p>Please fulfill the following conditions for Voice update -</p>
            <p class="dispute-alert__modal__body__content--p">
              To update DwV dispute stage should be either
              <span class="dispute-alert__modal__body__content--strong">
                Reject with Voice
              </span>
              or
              <span class="dispute-alert__modal__body__content--strong">
                Reject.
              </span>
            </p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import DisputeWithVoiceForm from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/DisputeWithVoiceForm.vue";
import {
  statusCodesToEnableDwV,
  disputeStatusToEnableDwV,
} from "@/config/disputeUpdateModalConstant.js";

export default {
  name: "DisputeWithVoiceModal",
  components: {
    DisputeWithVoiceForm,
  },
  props: {
    caseDetails: {
      type: Object,
      default: () => {},
    },
    voiceDisputeData: {
      type: Object,
      default: () => {},
    },
    disputesConstants: {
      type: Object,
      default: () => {},
    },
    disputeSelectedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDelete: false,
      statusCodesToEnableDwV,
      disputeStatusToEnableDwV,
    };
  },
  created() {
    if (this.voiceDisputeData && Object.keys(this.voiceDisputeData).length) {
      this.showDelete = true;
    }
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onSubmitClick() {
      this.$refs.disputeWithVoiceForm.onSubmitCalled();
    },
    onSubmit(formState, changedFields) {
      const { contactPerson, contactEmail } = this.caseDetails;
      const contactDetails = {
        contactPerson: formState.contactPerson,
        contactEmail: formState.contactEmail,
        contactTelNumber: formState.contactTelNumber,
        updateRequestType: "CUSTOMER",
      };
      if (
        typeof contactPerson === "undefined" ||
        typeof contactEmail === "undefined" ||
        !contactPerson ||
        !contactEmail
      ) {
        this.$emit("updateContactDetails", contactDetails, () =>
          this.saveActions(formState, changedFields)
        );
      } else {
        this.saveActions(formState, changedFields);
      }
    },
    saveActions(formState, changedFields) {
      const disputeVoiceAgentId = formState.ohpDisputeVoiceAgent.apmId;
      if (this.voiceDisputeData && Object.keys(this.voiceDisputeData).length) {
        const { ohpDisputeVoiceId, ohpDisputeId } = this.voiceDisputeData;
        this.$emit(
          "updateVoiceDispute",
          {
            ...changedFields,
            ohpDisputeVoiceId,
            ohpDisputeId,
            ohpDisputeVoiceAgent:
              this.voiceDisputeData?.ohpDisputeVoiceAgent !==
              disputeVoiceAgentId
                ? disputeVoiceAgentId
                : undefined,
          },
          this.$emit("onModalClose")
        );
      } else if (this.disputeSelectedRows.length) {
        this.$emit(
          "createBulkVoiceDisputes",
          this.disputeSelectedRows.map((item) => ({
            ...formState,
            ohpDisputeId: item.ohpDisputeId,
            ohpDisputeVoiceAgent: disputeVoiceAgentId,
          })),
          this.$emit("onModalClose")
        );
      } else {
        this.$emit(
          "createVoiceDisputes",
          { ...formState, ohpDisputeVoiceAgent: disputeVoiceAgentId },
          this.$emit("onModalClose")
        );
      }
    },
    onDelete() {
      const { ohpDisputeVoiceId, ohpDisputeId } = this.voiceDisputeData;
      this.$emit(
        "deleteVoiceDispute",
        { ...this.fieldValues, ohpDisputeVoiceId, ohpDisputeId },
        this.$emit("onModalClose")
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";
.voice-modal {
  .modal--medium {
    width: 948px;
    height: calc(100vh - 65px);
  }
  .mx-datepicker {
    width: 100%;
  }
}
.alert {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;

  .modal--small {
    height: 320px;
  }

  &__content {
    margin-left: 1rem;

    &--strong {
      font-family: "Maersk Text Bold";
    }
    &--p {
      margin-top: 1rem;
    }
  }
}
</style>
